import React from 'react';
import { computeProviders } from '../../data/stack';
import { ComputeProvider } from '../../types/content';
import { SourceRef } from '../SourceRef';
const KIND_STYLE: Record<ComputeProvider['kind'], string> = {
  Neocloud: 'border-machine/40 text-machine',
  Marketplace: 'border-live/40 text-live',
  Hyperscaler: 'border-human/40 text-human'
};
export function ComputeTab() {
  return <section aria-labelledby="compute-title" data-id="element-438" data-mp="ukynwxugwyy2">
      <h2 id="compute-title" className="font-serif text-2xl text-ink md:text-3xl" data-id="element-439" data-mp="uk6qdhhb8r55">
        GPU clouds
      </h2>
      <p className="mt-2 max-w-2xl text-[14px] text-muted" data-id="element-440" data-mp="yjxn01tiq1hl">Who rents out the silicon. Scale figures are public disclosures only — filings, launch announcements or vendor pages. “Not disclosed” means exactly that.</p>
      <div className="mt-5 overflow-x-auto rounded-lg border border-line" data-id="element-441" data-mp="1dawuf9imajzl">
        <table className="w-full min-w-[1040px] border-collapse text-[13.5px]" data-id="element-442" data-mp="1d8tt3tc0l4fk">
          <thead className="bg-surface text-left text-[12px] text-muted" data-id="element-443" data-mp="1iaj5pdevxq5r">
            <tr data-id="element-444" data-mp="19zqe17z33rte">
              {['Provider', 'Silicon offered', 'Scale signal', 'Hourly price signal'].map(h => <th key={h} scope="col" className="whitespace-nowrap border-b border-line px-3 py-2.5 font-normal" data-id="element-445" data-mp="14zlvlcem8n0j">
                  {h}
                </th>)}
            </tr>
          </thead>
          <tbody data-id="element-446" data-mp="w1a0ax2t111r">
            {computeProviders.map(c => <tr key={c.name} className="border-b border-line/60 last:border-b-0" data-id="element-447" data-mp="1sq7twbytisxc">
                <th scope="row" className="px-3 py-3 text-left font-normal" data-id="element-448" data-mp="1nr4xffwwlv0z">
                  <span className="whitespace-nowrap text-ink" data-id="element-449" data-mp="1nt7q67pfy29e">{c.name}</span>
                  <SourceRef href={c.sourceUrl} data-id="element-450" data-mp="1iyby57k7fewa" />
                  <span className={`ml-2 rounded border px-1.5 py-px font-mono text-[10px] ${KIND_STYLE[c.kind]}`} data-id="element-451" data-mp="1ez3401l95f07">{c.kind}</span>
                </th>
                <td className="px-3 py-3 font-mono text-[12.5px] text-ink/90" data-id="element-452" data-mp="2bhqzmqk88l32">{c.silicon}</td>
                <td className={`px-3 py-3 ${c.scale.startsWith('Not disclosed') ? 'text-faint' : 'text-ink'}`} data-id="element-453" data-mp="26ofxv3u9uui0">
                  {c.scale}
                  {!c.scale.startsWith('Not disclosed') && <SourceRef href={c.scaleSourceUrl ?? c.sourceUrl} data-id="element-454" data-mp="9pywhzazz1k2" />}
                </td>
                <td className={`px-3 py-3 font-mono text-[12.5px] ${/\$/.test(c.price) ? 'text-machine' : 'text-muted'}`} data-id="element-455" data-mp="3r6qeaoodu6g0">
                  {c.price}
                  <SourceRef href={c.sourceUrl} data-id="element-456" data-mp="3i73eu8f7rapl" />
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </section>;
}